import React from "react";
import PageLayout from "../../PageLayout";
import SecondPage from "./SecondPage";
import FourthPage from "./FourthPage";
import VideoCareer from "./VideoCareer";

const videos = [
 
];

function Aerial() {
  return (
    <div>
      <PageLayout
        title="Let us give wings to your stories"
        description="We at IBEX FILMZ understand the evolving landscape of digital media and its impact on audiences worldwide. Leveraging cutting-edge technology and creative storytelling, we ensure that each video or film we produce not only meets but exceeds the expectations of our clients. Our team of experts specializes in bringing ideas to life, transforming visions into cinematic experiences that resonate with viewers, leaving a lasting impression. "
        videosrc="./video.mp4"
      />
      <SecondPage
        title="Aerial Cinematography"
        para="Embark on a visual journey to captivating destinations with our Destination Promotional Videos playlist! 
Join us as we transport you to breathtaking locales, from sun-kissed beaches to bustling cityscapes, through our immersive and captivating videos. Whether you're dreaming of exotic getaways or seeking inspiration for your next adventure, our videos will ignite your wanderlust and showcase the beauty and allure of each destination."
      />
      <VideoCareer videos={videos} />
    </div>
  );
}

export default Aerial;
